import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { ProductScope } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CurrentProductService } from "@spartacus/storefront";
import { switchMap, take } from 'rxjs/operators';
import { GenApplicableProductsResponse } from 'src/app/generac/models/product.model';
import { GenProductService } from 'src/app/generac/services/product.service';

@Component({
    selector: 'gen-applicable-products',
    templateUrl: './applicable-products.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenApplicableProductsComponent implements OnDestroy {
  currentPage: number = 0;
  applicableProducts: GenApplicableProductsResponse;

  private subscriptions = new Subscription();

  constructor(
    protected currentProductService: CurrentProductService,
    protected productService: GenProductService,
    private cdr: ChangeDetectorRef,
  ) {
    this.getApplicableProductsByPage();
   }

  private getApplicableProductsByPage(): void {
    this.subscriptions.add(
      this.currentProductService.getProduct(
        ProductScope.ATTRIBUTES
      ).pipe(
        switchMap(product => this.productService.getApplicableProducts(product?.code, this.currentPage)),
        take(1),
      ).subscribe(res => {
        this.applicableProducts = res;
        this.cdr.markForCheck();
      })
    )
  }

  onPaginate(page: number): void {
    this.currentPage = page;
    this.getApplicableProductsByPage();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
